// Reveal-on-scroll for the md storytelling sections. IntersectionObserver
// only — no scroll listeners, the animation itself is pure CSS (opacity +
// transform, compositor-friendly). The hidden state is applied by this
// script, so without JS nothing is ever hidden; elements already inside the
// first viewport are skipped so the initial paint never flashes.

(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const SELECTORS = [
    '.md-story__grid > *',
    '.md-steps__heading',
    '.md-steps__grid > *',
    '.md-video',
    '.md-compare__heading',
    '.md-compare__row',
    '.md-anti__heading',
    '.md-anti__subheading',
    '.md-anti__grid > *',
    '.md-anti__closing',
    '.md-testimonials__heading',
    '.md-testimonials__grid > *',
    '.md-feature-grid__header',
    '.md-feature-grid__grid > *',
    '.mds-cta__inner',
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      // Entries that appear in the same batch get a small incremental delay,
      // so grids cascade item by item instead of popping in at once.
      let batchIndex = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const delay = Math.min(batchIndex * 90, 450);
        entry.target.style.setProperty('--md-reveal-delay', `${delay}ms`);
        entry.target.classList.add('md-reveal--in');
        observer.unobserve(entry.target);
        batchIndex += 1;
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  const targets = new Set();
  for (const selector of SELECTORS) {
    for (const el of document.querySelectorAll(selector)) targets.add(el);
  }

  const viewportHeight = window.innerHeight;
  for (const el of targets) {
    if (el.getBoundingClientRect().top < viewportHeight * 0.9) continue;
    el.classList.add('md-reveal');
    observer.observe(el);
  }
})();
